var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgHome03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 444,
    viewBox: "0 0 588 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_5016)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 588,
    height: 444,
    rx: 12,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip1_66_5016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-43.6318 328.56C-43.6318 323.79 -39.7649 319.923 -34.9949 319.923H82.4852C87.2552 319.923 91.1221 323.79 91.1221 328.56V398.572C91.1221 401.752 88.5442 404.33 85.3642 404.33H-37.8739C-41.0539 404.33 -43.6318 401.752 -43.6318 398.572V328.56Z",
    fill: "#0C7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-122.363 305C-127.133 305 -131 308.867 -131 313.637V392.242C-131 392.253 -131 392.264 -131 392.275V487.42C-131 490.6 -128.422 493.178 -125.242 493.178H95.7297C98.9098 493.178 101.488 490.6 101.488 487.42V341.97C101.488 338.79 98.9098 336.212 95.7297 336.212H-37V313.637C-37 308.867 -40.8669 305 -45.6369 305H-122.363Z",
    fill: "#3692FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip2_66_5016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.368 328.56C573.368 323.79 577.235 319.923 582.005 319.923H699.485C704.255 319.923 708.122 323.79 708.122 328.56V398.572C708.122 401.752 705.544 404.33 702.364 404.33H579.126C575.946 404.33 573.368 401.752 573.368 398.572V328.56Z",
    fill: "#0C7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.637 305C489.867 305 486 308.867 486 313.637V392.242C486 392.253 486 392.264 486 392.275V487.42C486 490.6 488.578 493.178 491.758 493.178H712.73C715.91 493.178 718.488 490.6 718.488 487.42V341.97C718.488 338.79 715.91 336.212 712.73 336.212H580V313.637C580 308.867 576.133 305 571.363 305H494.637Z",
    fill: "#3692FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_66_5016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.368 328.195C264.368 323.425 268.235 319.558 273.005 319.558H390.485C395.255 319.558 399.122 323.425 399.122 328.195V398.206C399.122 401.386 396.544 403.964 393.364 403.964H270.126C266.946 403.964 264.368 401.386 264.368 398.206V328.195Z",
    fill: "#0C7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.637 304.634C180.867 304.634 177 308.501 177 313.271V391.876C177 391.887 177 391.898 177 391.909V487.055C177 490.235 179.578 492.812 182.758 492.812H403.73C406.91 492.812 409.488 490.235 409.488 487.055V341.604C409.488 338.424 406.91 335.846 403.73 335.846H271V313.271C271 308.501 267.133 304.634 262.363 304.634H185.637Z",
    fill: "#3692FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 127.711C76 118.62 83.3697 111.25 92.4607 111.25H190.539C199.63 111.25 207 118.62 207 127.711V230.546C207 237.174 201.627 242.546 195 242.546H88C81.3726 242.546 76 237.174 76 230.546V127.711Z",
    fill: "#8698FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.307 143.469L127.395 130.549C127.572 129.806 128.58 129.688 128.923 130.37L134.897 142.227L141.929 202.586L131.338 203.828L124.307 143.469Z",
    fill: "#E02D2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.087 140.752C132.661 141.782 130.961 142.474 129.09 142.694C127.501 142.881 125.953 142.708 124.528 142.24L127.327 130.557C127.505 129.814 128.512 129.696 128.855 130.377L134.087 140.752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.236 133.162C129.706 133.422 129.125 133.599 128.506 133.671C127.844 133.749 127.198 133.702 126.588 133.548L127.305 130.559C127.482 129.817 128.489 129.698 128.833 130.38L130.236 133.162Z",
    fill: "#E02D2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.326 142.226L155.304 130.371C155.648 129.689 156.655 129.808 156.833 130.551L159.916 143.472L152.863 203.829L142.273 202.583L149.326 142.226Z",
    fill: "#292424"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.46 141.861C157.841 142.527 156.034 142.802 154.171 142.582C152.575 142.394 151.102 141.862 149.819 141.069L155.224 130.361C155.567 129.68 156.574 129.798 156.752 130.541L159.46 141.861Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.549 133.282C156.981 133.408 156.382 133.443 155.771 133.371C155.102 133.292 154.476 133.092 153.913 132.795L155.293 130.061C155.637 129.38 156.643 129.499 156.821 130.242L157.549 133.282Z",
    fill: "#292424"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.523 166.747C118.523 164.032 120.725 161.831 123.44 161.831H160.722C163.438 161.831 165.639 164.032 165.639 166.747V208.55C165.639 215.177 160.266 220.55 153.639 220.55H130.523C123.896 220.55 118.523 215.177 118.523 208.55V166.747Z",
    fill: "#5F76FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.523,
    y: 178.255,
    width: 47.1153,
    height: 20.9418,
    fill: "#FFD875"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237 127.711C237 118.62 244.37 111.25 253.461 111.25H351.539C360.63 111.25 368 118.62 368 127.711V230.546C368 237.174 362.627 242.546 356 242.546H249C242.373 242.546 237 237.174 237 230.546V127.711Z",
    fill: "#B9D9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.979 138.547L327.537 134.944C330.22 134.77 332.492 136.899 332.492 139.588V211.31C332.492 213.88 330.408 215.963 327.838 215.963H271.979V138.547Z",
    fill: "#F3F4F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M271.979 138.547L328.74 140.862C331.234 140.964 333.204 143.015 333.204 145.512V214.27C333.204 216.936 330.969 219.057 328.307 218.917L271.979 215.963V138.547Z",
    fill: "#4E93EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.643 139.974L322.169 140.509V160.309L315.406 156.242L308.643 160.309V139.974Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M393 127.083C393 118.339 400.088 111.25 408.832 111.25H508.168C516.912 111.25 524 118.339 524 127.083V230.546C524 237.174 518.627 242.546 512 242.546H405C398.373 242.546 393 237.174 393 230.546V127.083Z",
    fill: "#FFB9E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M451.794 179.78C451.997 179.112 453.502 177.775 457.894 177.775C462.286 177.775 463.994 179.112 464.299 179.78",
    stroke: "#FF46C0",
    strokeWidth: 3.84902
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M448.054 186.556L447.031 187.42V187.535C446.76 187.749 446.452 187.995 446.112 188.267C444.967 189.186 443.434 190.43 441.767 191.784C441.232 192.219 440.683 192.666 440.128 193.117C437.229 195.475 434.172 197.961 432.096 199.615C431.778 199.848 431.209 199.848 430.891 199.615C428.422 197.648 424.498 194.442 421.147 191.689C419.468 190.31 417.937 189.048 416.813 188.119C416.075 187.508 415.558 187.079 415.276 186.845C415.104 186.701 415.019 186.631 415.027 186.638C412.843 184.624 411.661 182.034 411.661 179.378V179.012C411.855 173.92 416.682 169.339 422.79 169.339C423.608 169.339 424.751 169.607 425.915 170.184C426.982 170.714 427.872 171.409 428.45 172.13C429.818 174.65 433.595 174.592 434.852 171.956C435.302 171.259 436.129 170.546 437.222 169.984C438.382 169.387 439.513 169.13 440.197 169.13C446.472 169.13 451.131 173.657 451.326 179.01V179.378C451.326 182.288 450.113 184.815 448.054 186.556Z",
    stroke: "#FF68CC",
    strokeWidth: 5.77353
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M500.076 186.556L499.053 187.42V187.535C498.783 187.749 498.474 187.995 498.135 188.267C496.989 189.186 495.456 190.43 493.79 191.784C493.254 192.219 492.705 192.666 492.15 193.117C489.252 195.475 486.194 197.961 484.118 199.615C483.801 199.848 483.231 199.848 482.914 199.615C480.444 197.648 476.52 194.442 473.169 191.689C471.49 190.31 469.96 189.048 468.835 188.119C468.097 187.508 467.58 187.079 467.299 186.845C467.126 186.701 467.042 186.631 467.049 186.638C464.866 184.624 463.684 182.034 463.684 179.378V179.012C463.878 173.92 468.704 169.339 474.813 169.339C475.631 169.339 476.774 169.607 477.937 170.184C479.005 170.714 479.895 171.409 480.472 172.13C481.841 174.65 485.617 174.592 486.875 171.956C487.324 171.259 488.152 170.546 489.245 169.984C490.405 169.387 491.535 169.13 492.22 169.13C498.494 169.13 503.154 173.657 503.349 179.01V179.378C503.349 182.288 502.135 184.815 500.076 186.556Z",
    stroke: "#FF68CC",
    strokeWidth: 5.77353
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M414.53 140.505C414.61 140.035 415.285 140.035 415.365 140.505L415.718 142.573C416.404 146.59 418.962 150.041 422.606 151.865C422.842 151.983 422.842 152.32 422.606 152.438C418.962 154.262 416.404 157.713 415.718 161.73L415.365 163.798C415.285 164.268 414.61 164.268 414.53 163.798L414.176 161.73C413.49 157.713 410.932 154.262 407.288 152.438C407.053 152.32 407.053 151.983 407.288 151.865C410.932 150.041 413.49 146.59 414.176 142.573L414.53 140.505Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M430.8 136.196C430.85 135.897 431.279 135.897 431.33 136.196L431.554 137.526C431.978 140.049 433.574 142.22 435.855 143.379C436.002 143.454 436.002 143.664 435.855 143.739C433.574 144.897 431.978 147.069 431.554 149.592L431.33 150.922C431.279 151.221 430.85 151.221 430.8 150.922L430.576 149.592C430.151 147.069 428.555 144.897 426.275 143.739C426.128 143.664 426.128 143.454 426.275 143.379C428.555 142.22 430.151 140.049 430.576 137.526L430.8 136.196Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M413.486 266.107C411.67 263.329 412.447 259.6 415.221 257.778C417.995 255.957 421.716 256.732 423.532 259.51L506.271 386.099C508.087 388.877 507.31 392.606 504.535 394.427C501.761 396.249 498.04 395.474 496.225 392.696L413.486 266.107Z",
    fill: "#374151"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.005 267.884L418.959 274.482L413.486 266.107C411.67 263.329 412.447 259.6 415.221 257.779C417.995 255.957 421.716 256.732 423.532 259.51L429.005 267.884Z",
    fill: "#3692FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M418.966 274.487L429.005 267.894C429.912 269.283 429.524 271.146 428.138 272.056L423.118 275.352C421.732 276.262 419.873 275.875 418.966 274.487Z",
    fill: "#111827"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_5016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H588V432C588 438.627 582.627 444 576 444H12C5.37258 444 0 438.627 0 432V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_66_5016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 162,
    fill: "white",
    transform: "translate(-159 282)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_66_5016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 162,
    fill: "white",
    transform: "translate(458 282)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_66_5016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149 281.634H442V432C442 438.627 436.627 444 430 444H161C154.373 444 149 438.627 149 432V281.634Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHome03);
export default __webpack_public_path__ + "static/media/img_home_03.d40ca5fe12dd9e5c2d2c741423e400d1.svg";
export { ForwardRef as ReactComponent };